/*
 * Mengen-Auswahl mit Staffelrabatt für die Ornamente (snippets/ornamente-set.liquid).
 * Steuert das teeinblue-Formular im Hintergrund: Für jedes Ornament werden Form und Wunschname
 * ins teeinblue-Formular gesetzt und dessen "In den Warenkorb" ausgelöst, damit jede Position
 * ihr eigenes teeinblue-Design (Druckdatei) bekommt.
 * Form: Die Formwahl von teeinblue oben gilt für alle Ornamente; ab zwei Ornamenten kann jedes
 * in seiner Zeile eine eigene Form bekommen. Die Vorschau zeigt immer das aktive Ornament.
 * Geschenkverpackung: Ist der Schalter des Blocks "Geschenkverpackung hinzufügen" an, kommt je
 * Ornament eine Verpackung mit in den Warenkorb.
 * Auswahl je Ornament (data-je-stueck, z. B. „Hunderasse“, Alex 30.10.2026): Das Bild-Feld oben gilt für das gerade
 * gewählte Ornament, jede Zeile zeigt ihre Wahl als Bild-Knopf mit Raster. Übernommen aus der Socken-Box.
 * Findet das Skript kein teeinblue-Formular, bleibt die Seite unverändert.
 */
(() => {
  const root = document.querySelector('[data-oset]');
  if (!root || root.dataset.osetInit) return;
  root.dataset.osetInit = '1';

  // ---------- Einstellungen aus dem Snippet ----------
  let PRICE = parseInt(root.dataset.unitCents, 10) || 0; // Cent
  const TIERS = (root.dataset.tiers || '')
    .split(',')
    .map((p) => p.split(':').map(Number))
    .filter(([n, v]) => n > 0 && v >= 0)
    .sort((a, b) => a[0] - b[0]);
  const FREE = parseInt(root.dataset.free, 10) || 0;
  const SHIP = parseInt(root.dataset.ship, 10) || 0;
  const OPTIONS = (root.dataset.options || '1,2,3,4').split(',').map(Number).filter((n) => n > 0);
  const MAX = Math.max(...OPTIONS);

  const fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  const eur = (cents) => fmt.format(cents / 100);
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const el = (tag, cls, text) => {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  };
  const plural = (n) => (n === 1 ? '1 Ornament' : `${n} Ornamente`);

  async function waitUntil(fn, timeoutMs, step = 120) {
    const t0 = Date.now();
    while (Date.now() - t0 < timeoutMs) {
      try { if (fn()) return true; } catch (e) { /* weiter warten */ }
      await sleep(step);
    }
    return false;
  }

  // ---------- Warenkorb ----------
  // Der Mengenrabatt im Shop zählt alle Ornament-Motive zusammen. Liegen schon Ornamente im
  // Warenkorb, rechnen Kacheln und Zusammenfassung deshalb mit der Stufe für alle zusammen.
  const handles = new Set([...document.querySelectorAll('[data-omotiv] a[data-handle]')].map((a) => a.dataset.handle));
  if (root.dataset.handle) handles.add(root.dataset.handle);
  // alle Ornamente mit Mengenrabatt, auch die ohne Kachel (Foto, Familie …, Alex 19.10.2026)
  (root.dataset.rabattHandles || '').split(',').map((s) => s.trim()).filter(Boolean).forEach((h) => handles.add(h));
  let imKorb = 0; // Ornamente, die schon im Warenkorb liegen
  let korbLeer = true;
  function readCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    imKorb = cart.items.reduce((s, it) => s + (handles.has(it.handle) ? it.quantity : 0), 0);
    korbLeer = !cart.item_count;
    return true;
  }
  async function fetchCart() {
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const r = await fetch(`${base}cart.js`, { headers: { Accept: 'application/json' } });
    return r.json();
  }
  async function loadCart() {
    try { readCart(await fetchCart()); } catch (e) { /* ohne Warenkorb-Daten rechnen wir nur mit dieser Auswahl */ }
  }

  // ---------- Geschenkverpackung (Block "ck-ab-gift-wrap" der Vorlage) ----------
  // Der Schalter des Themes legt bei teeinblue-Produkten selbst nichts in den Warenkorb. Das
  // übernimmt hier die Mengen-Auswahl: eine Verpackung je Ornament, im Preis klar ausgewiesen.
  const boxWrap = document.querySelector('.ck-ab-gift-wrap');
  const boxCheck = boxWrap && boxWrap.querySelector('input[type="checkbox"]');
  const BOX_ID = boxWrap ? parseInt(boxWrap.dataset.giftVariant, 10) || 0 : 0;
  const BOX_PRICE = boxWrap ? parseInt(boxWrap.dataset.giftPrice, 10) || 0 : 0;
  const boxAn = () => !!(BOX_ID && boxCheck && boxCheck.checked);
  const boxSumme = (n) => (boxAn() ? BOX_PRICE * n : 0);
  let boxNote = null;
  function renderBoxNote() {
    if (!boxWrap || !BOX_ID) return;
    if (!boxNote) {
      boxNote = el('p', 'oset-boxnote');
      const preis = boxWrap.querySelector('.ck-ab-gift-wrap-price');
      (preis && preis.parentElement ? preis.parentElement : boxWrap).appendChild(boxNote);
    }
    boxNote.hidden = qty < 2;
    boxNote.textContent = `Eine Verpackung je Ornament: ${qty} × ${eur(BOX_PRICE)} = ${eur(BOX_PRICE * qty)}`;
  }
  async function addBoxes(n) {
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const r = await fetch(`${base}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: BOX_ID, quantity: n }] })
    });
    if (!r.ok) throw new Error('Geschenkverpackung');
  }
  // Warenkorb-Fenster des Themes neu zeichnen (nötig nach dem eigenen Hinzufügen der Verpackung)
  function refreshDrawer(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
  }

  const pct = (n) => TIERS.reduce((p, [min, v]) => (imKorb + n >= min ? v : p), 0);
  const unit = (n) => Math.round((PRICE * (100 - pct(n))) / 100);
  const total = (n) => unit(n) * n;
  const shipFor = (sub) => (FREE && sub >= FREE ? 0 : SHIP);

  // ---------- teeinblue-Formular ----------
  const scope = () => document.querySelector('form.tee-form-wrapper') || document;
  const tee = {
    textInput: () => scope().querySelector('.tee-field--text input'),
    textField: () => scope().querySelector('.tee-field--text'),
    atc: () => scope().querySelector('.tee-btn--atc'),
    formOption: () => scope().querySelector('.tee-option--color')
  };
  const formRadios = () => { const o = tee.formOption(); return o ? [...o.querySelectorAll('input[type="radio"]')] : []; };
  const formValue = () => (formRadios().find((i) => i.checked) || {}).value || null;

  // ---------- Textfelder ----------
  // Die ersten Ornamente haben genau ein Textfeld (Wunschname). Die neuen haben teils mehrere (Familie Hände:
  // Papa, Mama, Kinder, Wunschtext; Familie Socken: Familienname, Vornamen, Jahr) oder keins (Musik).
  // Die Box zeigt je Ornament alle Textfelder; Foto, Design, Figuren, Hautfarben usw. wählt der Kunde oben im
  // teeinblue-Formular, sie gelten für alle Ornamente dieser Bestellung (wie das Motiv). Alex 19.10.2026.
  const feldKey = (f) => { const c = [...f.classList].find((x) => /^tee-field--layer-[\w-]+$/.test(x)); return c ? c.slice(17) : null; };
  // Eingabefeld eines Textfelds: meist type="text", die Jahreszahl bei Familie Socken ist type="number"
  const EINGABE = 'input:not([type="radio"]):not([type="checkbox"]):not([type="file"]):not([type="hidden"]), textarea';
  function liesFelder() {
    return [...scope().querySelectorAll('.tee-field--text')].filter((f) => !f.classList.contains('sr-only')).map((f) => {
      const inp = f.querySelector(EINGABE);
      const h = f.querySelector('.tee-field__heading');
      const vorgabe = inp ? inp.value : '';
      return {
        key: feldKey(f),
        titel: ((h && h.textContent) || '').replace('*', '').trim() || 'Text',
        max: inp && inp.maxLength > 0 ? inp.maxLength : 40,
        zahl: !!(inp && inp.type === 'number'),
        platzhalter: (inp && inp.placeholder) || '',
        pflicht: !!(h && h.querySelector('.tee-asterisk')) || !!(inp && inp.required),
        // Vorgabetext von teeinblue (z. B. „Frohe Weihnachten“) wie im normalen Formular vorbelegen
        vorgabe: vorgabe && vorgabe !== 'undefined' ? vorgabe : ''
      };
    }).filter((x) => x.key);
  }
  const feldInput = (key) => scope().querySelector(`.tee-field--layer-${key}`)?.querySelector(EINGABE) || null;
  // weitere Auswahlfelder (Foto, Design, Figuren …) außer den Textfeldern und der Buchstaben-Auswahl
  const hatAuswahl = () => [...scope().querySelectorAll('.tee-field')].some((f) => !f.classList.contains('sr-only') && !f.classList.contains('tee-field--text') && !f.classList.contains('oset-auto')
    && !JE_STUECK.includes(feldTitel(f).toLowerCase()));
  const hatFoto = () => !!scope().querySelector('.tee-field--photo');

  // Buchstaben-Ornament: Eine Auswahl, deren Optionen nur einzelne Buchstaben sind, stellt die Box je Ornament
  // auf den Anfangsbuchstaben des Namens (sonst hätte jedes Ornament den Buchstaben des ersten).
  const buchstabeVon = (f) => ((f.querySelector('.tee-clipart-label__text') || {}).textContent || '').trim().toUpperCase();
  function buchstabenFeld() {
    return [...scope().querySelectorAll('.tee-field--clipart')].find((f) => {
      const t = [...f.querySelectorAll('.tee-clipart')].map(buchstabeVon);
      return t.length >= 20 && t.every((x) => /^[A-ZÄÖÜ]$/.test(x));
    }) || null;
  }
  const anfang = (text) => { const c = (String(text || '').trim()[0] || '').toUpperCase(); return ({ 'Ä': 'A', 'Ö': 'O', 'Ü': 'U' })[c] || c; };
  const buchstabeOption = (feld, text) => [...feld.querySelectorAll('.tee-clipart')].find((c) => buchstabeVon(c) === anfang(text)) || null;
  function setzeBuchstabe(text) {
    const feld = buchstabenFeld();
    if (!feld || !String(text || '').trim()) return;
    feld.classList.add('oset-auto');
    const opt = buchstabeOption(feld, text);
    const inp = opt && opt.querySelector('input[type="radio"]');
    if (!inp || inp.checked) return;
    (opt.querySelector('label') || inp).click();
  }
  const buchstabeSteht = (text) => {
    const feld = buchstabenFeld();
    if (!feld || !String(text || '').trim()) return true;
    const opt = buchstabeOption(feld, text);
    return !!(opt && opt.querySelector('input[type="radio"]').checked);
  };

  // ---------- Auswahl je Ornament (data-je-stueck, z. B. „Hunderasse“) ----------
  // Jedes Ornament bekommt seine eigene Wahl: Die Zeile zeigt das gewählte Bild (Antippen öffnet die Auswahl), vor dem
  // Anlegen stellt die Box es im teeinblue-Formular ein. Das Feld oben bleibt sichtbar und gilt für das gerade gewählte
  // Ornament (Alex 30.10.2026: bei „Hunde Weihnachten Wasserfarbe“ je Ornament ein anderer Hund). Aus der Socken-Box.
  const JE_STUECK = (root.dataset.jeStueck || '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
  // Feldtitel ohne Sternchen und ohne den eigenen Zusatz „für Ornament 2“ (.oset-fuer, siehe markiereFeld)
  const feldTitel = (f) => {
    const h = f.querySelector('.tee-field__heading');
    if (!h) return '';
    return [...h.childNodes]
      .filter((n) => !(n.classList && (n.classList.contains('oset-fuer') || n.classList.contains('tee-asterisk'))))
      .map((n) => n.textContent).join('').replace('*', '').trim();
  };
  function jeStueckFelder() {
    return [...scope().querySelectorAll('.tee-field--clipart')]
      .filter((f) => JE_STUECK.includes(feldTitel(f).toLowerCase()))
      .map((f) => ({ key: feldKey(f), titel: feldTitel(f), el: f }))
      .filter((x) => x.key);
  }
  function optionen(feld) {
    return [...feld.querySelectorAll('input[type="radio"]')].map((input) => {
      const holder = input.closest('.tee-clipart') || input.parentElement;
      const img = holder && holder.querySelector('img');
      const txt = holder && holder.querySelector('.tee-clipart-label__text');
      const thumb = img ? img.getAttribute('data-src') || img.currentSrc || img.src || '' : '';
      return { value: input.value, label: ((txt && txt.textContent) || (img && img.alt) || '').trim(), thumb };
    }).filter((o) => o.value);
  }
  // teeinblue übernimmt eine Auswahl nur über den Klick auf das <label>; Scroll-Position bleibt
  function waehleOption(feld, value) {
    const input = [...feld.querySelectorAll('input[type="radio"]')].find((x) => x.value === value);
    if (!input || input.checked) return;
    const holder = input.closest('.tee-clipart') || input.parentElement;
    const label = (input.id && feld.querySelector(`label[for="${CSS.escape(input.id)}"]`)) || holder.querySelector('label') || input;
    const x = window.scrollX;
    const y = window.scrollY;
    progAuswahl = true;
    try { label.click(); } finally { progAuswahl = false; }
    if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
  }
  let progAuswahl = false; // true, solange die Box selbst eine Auswahl im teeinblue-Formular klickt
  const setzeJeStueck = (a) => jeStueckFelder().forEach((f) => { if (a && a[f.key]) waehleOption(f.el, a[f.key]); });
  const jeStueckSteht = (a) => jeStueckFelder().every((f) => {
    const v = a && a[f.key];
    if (!v) return true;
    const i = [...f.el.querySelectorAll('input[type="radio"]')].find((x) => x.value === v);
    return !!(i && i.checked);
  });
  const wahl = Array.from({ length: MAX }, () => ({})); // je Ornament: Feld-Key → gewählte Option (teeinblue-Wert)
  const wahlName = (a) => jeStueckFelder().map((f) => (optionen(f.el).find((o) => o.value === (a || {})[f.key]) || {}).label).filter(Boolean).join(', ');

  // ---------- Zustand ----------
  let textTitle = 'Wunschname';
  let maxLen = 20;
  let qty = Math.min(MAX, Math.max(1, parseInt(root.dataset.default, 10) || 1));
  let active = 0;
  let busy = false;
  let felder = []; // Textfelder des teeinblue-Formulars: { key, titel, max, pflicht, vorgabe }
  const werte = Array.from({ length: MAX }, () => ({})); // je Ornament: Feld-Key → Text
  const erstes = (w) => (felder[0] && w ? String(w[felder[0].key] || '') : '');
  const sauber = (w) => Object.fromEntries(felder.map((f) => [f.key, String((w && w[f.key]) || '').trim()]));
  let formen = []; // wählbare Formen (Werte der teeinblue-Formwahl)
  let basis = null; // Form aller Ornamente ohne eigene Wahl (= oben gewählte Form)
  const eigen = Array.from({ length: MAX }, () => null); // eigene Form je Ornament
  const formOf = (i) => eigen[i] || basis;
  let eigeneFormen = true; // aus bei Foto-Ornamenten (das Foto gilt für alle, Formwechsel nur oben)

  // für den Motiv-Wechsel (assets/ornamente-motiv.js): Anzahl, Namen und Formen wandern mit
  window.ornamenteSet = { zustand: () => ({ qty, namen: werte.slice(0, qty).map(erstes), basis, formen: eigen.slice(0, qty) }) };

  // Texte (und ggf. Buchstabe und Auswahl je Ornament) eines Ornaments ins teeinblue-Formular schreiben (Vorschau und Warenkorb)
  function applyToTee(w, a) {
    felder.forEach((f) => {
      const inp = feldInput(f.key);
      const v = String((w && w[f.key]) || '').trim();
      if (!inp || inp.value === v) return;
      inp.value = v;
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    setzeBuchstabe(erstes(w));
    setzeJeStueck(a);
  }

  // teeinblue übernimmt eine Form nur über den Klick auf deren <label>. Scroll-Position und Fokus
  // bleiben dabei, wo sie waren. progKlick: unser Klick, nicht der des Kunden (siehe Start).
  let progKlick = false;
  function klickForm(form) {
    if (!form || formValue() === form) return false;
    const input = formRadios().find((i) => i.value === form);
    if (!input) return false;
    const label = (input.id && tee.formOption().querySelector(`label[for="${CSS.escape(input.id)}"]`)) || input;
    const prev = document.activeElement;
    const x = window.scrollX;
    const y = window.scrollY;
    progKlick = true;
    try { label.click(); } finally { progKlick = false; }
    if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
    if (prev && prev !== document.activeElement && typeof prev.focus === 'function') prev.focus({ preventScroll: true });
    return true;
  }
  // Nach einem Formwechsel leert teeinblue gut eine halbe Sekunde später die Eingaben und meldet
  // das als "customization-changed". Erst danach bleibt ein gesetzter Name stehen.
  function nextCustomization(timeoutMs) {
    return new Promise((resolve) => {
      let done = false;
      const finish = (v) => {
        if (done) return;
        done = true;
        document.removeEventListener('teeinblue-event-customization-changed', on);
        resolve(v);
      };
      const on = () => finish(true);
      document.addEventListener('teeinblue-event-customization-changed', on);
      setTimeout(() => finish(false), timeoutMs);
    });
  }
  // teeinblue auf ein Ornament stellen: erst die Form, dann die Texte
  async function stelleEin(form, w, wartenMs, a) {
    if (form && formValue() !== form && formRadios().some((i) => i.value === form)) {
      // mit Text im Feld löst das Leeren nach dem Wechsel sicher die Meldung aus
      if (felder.some((f) => (w || {})[f.key])) { applyToTee(w, a); await sleep(40); }
      const geleert = nextCustomization(wartenMs);
      if (klickForm(form)) {
        await geleert;
        await waitUntil(() => formValue() === form && (!felder.length || feldInput(felder[0].key)), 4000, 60);
      }
    }
    applyToTee(w, a);
  }
  // Aufrufe nacheinander abarbeiten, damit sich Formwechsel nicht überholen
  let kette = Promise.resolve();
  const nacheinander = (fn) => { kette = kette.then(fn, fn); return kette; };
  let syncT = null;
  function syncPreview() {
    clearTimeout(syncT);
    syncT = setTimeout(() => {
      nacheinander(() => (busy ? null : stelleEin(formOf(active), sauber(werte[active]), 1500, wahl[active])));
    }, 150);
  }

  // ---------- Darstellung ----------
  const tilesBox = root.querySelector('[data-tiles]');
  const korbHint = root.querySelector('[data-korb-hint]');
  const namesBox = root.querySelector('[data-names]');
  const namesTitle = root.querySelector('[data-names-title]');
  const namesHint = root.querySelector('[data-names-hint]');
  const summaryBox = root.querySelector('[data-summary]');
  const ctaBtn = root.querySelector('[data-cta]');
  const ctaLabel = root.querySelector('[data-cta-label]');
  const errBox = root.querySelector('[data-err]');

  function renderTiles() {
    tilesBox.textContent = '';
    OPTIONS.forEach((n) => {
      const b = el('button', 'oset__tile' + (n === qty ? ' is-on' : ''));
      b.type = 'button';
      b.setAttribute('aria-pressed', String(n === qty));
      if (pct(n)) b.appendChild(el('span', 'oset__tag', `−${pct(n)} %`));
      b.appendChild(el('span', 'oset__tile-n', plural(n)));
      b.appendChild(el('span', 'oset__tile-t', eur(total(n))));
      b.appendChild(el('span', 'oset__tile-u', n === 1 && !pct(n) ? 'Einzelpreis' : `je ${eur(unit(n))}`));
      if (korbLeer && FREE && total(n) >= FREE) b.appendChild(el('span', 'oset__tile-ship', 'Versandkostenfrei'));
      b.addEventListener('click', () => setQty(n));
      tilesBox.appendChild(b);
    });
    korbHint.hidden = !imKorb;
    if (imKorb) {
      korbHint.textContent = imKorb === 1
        ? 'Im Warenkorb liegt schon 1 Ornament. Es zählt für den Mengenrabatt mit.'
        : `Im Warenkorb liegen schon ${imKorb} Ornamente. Sie zählen für den Mengenrabatt mit.`;
    }
  }

  function setQty(n) {
    if (busy) return;
    const vorher = qty;
    qty = Math.max(1, Math.min(MAX, n));
    for (let i = vorher; i < qty; i++) wahl[i] = { ...wahl[active] };
    if (active >= qty) active = qty - 1;
    errBox.textContent = '';
    renderTiles();
    renderNames();
    renderPrices();
    markiereFeld();
    syncPreview();
  }

  function setActive(i) {
    active = i;
    namesBox.querySelectorAll('.oset__name').forEach((r) => r.classList.toggle('is-active', qty > 1 && Number(r.dataset.i) === i));
    markiereFeld();
    syncPreview();
  }
  // Auswahlfeld je Ornament oben (teeinblue): gilt immer für das gerade gewählte Ornament → ab 2 steht dran, für welches
  function markiereFeld() {
    jeStueckFelder().forEach((f) => {
      const h = f.el.querySelector('.tee-field__heading');
      if (!h) return;
      let fuer = h.querySelector('.oset-fuer');
      if (!fuer) { fuer = el('span', 'oset-fuer'); h.appendChild(fuer); }
      const name = erstes(werte[active]).trim();
      const text = qty > 1 ? `für Ornament ${active + 1}${name ? ` (${name})` : ''}` : '';
      if (fuer.textContent !== text) fuer.textContent = text;
      fuer.hidden = !text;
    });
  }

  // Hinweis unter den Zeilen: bei den ersten Ornamenten der Text aus dem Snippet, bei Ornamenten mit Foto/Auswahl
  // ein eigener (die Auswahl oben gilt für alle Ornamente dieser Bestellung, außer den Feldern je Ornament)
  const hinweisMotiv = namesHint.textContent;
  function hinweisText() {
    const je = jeStueckFelder();
    const jeSatz = je.length
      ? `${je.map((f) => `„${f.titel}“`).join(' und ')} wählst du je Ornament: Ornament antippen und oben auswählen oder direkt auf das Bild in der Zeile tippen.`
      : '';
    if (!hatAuswahl()) return jeSatz ? `${jeSatz} Der Mengenrabatt zählt alle Ornamente im Warenkorb zusammen.` : hinweisMotiv;
    const teile = [];
    if (jeSatz) teile.push(jeSatz);
    teile.push(hatFoto()
      ? `Foto und ${je.length ? 'übrige ' : ''}Auswahl oben gelten für alle Ornamente dieser Bestellung.`
      : `Die ${je.length ? 'übrige ' : ''}Auswahl oben (z. B. Design, Figuren, Farben) gilt für alle Ornamente dieser Bestellung.`);
    if (buchstabenFeld()) teile.push('Der Buchstabe kommt automatisch aus dem jeweiligen Namen.');
    if (eigeneFormen && formen.length > 1) teile.push('Jedes Ornament kann eine eigene Form bekommen.');
    teile.push('Für eine andere Auswahl legst du danach einfach noch eines in den Warenkorb, der Mengenrabatt zählt zusammen.');
    return teile.join(' ');
  }

  // Auswahl je Ornament: Bild-Knopf in der Zeile, Antippen öffnet ein Raster mit allen Möglichkeiten
  let picker = null;
  const closePicker = () => { if (picker) { picker.remove(); picker = null; } };
  document.addEventListener('click', closePicker);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePicker(); });
  function chips(i, row) {
    return jeStueckFelder().map((f) => {
      const ops = optionen(f.el);
      const b = el('button', 'oset__chip');
      b.type = 'button';
      const sync = () => {
        const o = ops.find((x) => x.value === wahl[i][f.key]) || null;
        b.textContent = '';
        const im = el('img');
        im.alt = '';
        im.width = 46;
        im.height = 46;
        if (o) im.src = o.thumb;
        b.append(im, el('small', null, 'ändern'));
        b.setAttribute('aria-label', `${f.titel}${qty > 1 ? ` für Ornament ${i + 1}` : ''}: ${o && o.label ? o.label : 'gewählt'} – ändern`);
      };
      sync();
      b.addEventListener('click', (e) => {
        e.stopPropagation();
        const offen = picker && picker.dataset.fuer === `${i}-${f.key}`;
        closePicker();
        if (offen) return;
        const p = el('div', 'oset__picker');
        p.dataset.fuer = `${i}-${f.key}`;
        p.addEventListener('click', (ev) => ev.stopPropagation());
        p.appendChild(el('p', null, qty > 1 ? `${f.titel} für Ornament ${i + 1}` : f.titel));
        const grid = el('div', 'oset__grid');
        ops.forEach((o) => {
          const k = el('button', o.value === wahl[i][f.key] ? 'is-on' : '');
          k.type = 'button';
          if (o.label) k.title = o.label;
          k.setAttribute('aria-label', o.label || f.titel);
          const im = el('img');
          im.src = o.thumb;
          im.alt = '';
          im.loading = 'lazy';
          k.appendChild(im);
          k.addEventListener('click', () => {
            wahl[i][f.key] = o.value;
            closePicker();
            sync();
            if (active !== i) setActive(i); else syncPreview();
          });
          grid.appendChild(k);
        });
        p.appendChild(grid);
        row.appendChild(p);
        picker = p;
      });
      return b;
    });
  }

  // Zeile mit mehreren Textfeldern (oder keinem, z. B. Musik) je Ornament
  function zeileMehrfach(i) {
    const row = el('div', 'oset__name oset__name--multi' + (qty > 1 && i === active ? ' is-active' : ''));
    row.dataset.i = String(i);
    const kopf = el('div', 'oset__kopf');
    if (qty > 1) kopf.appendChild(el('span', 'oset__nr', `Ornament ${i + 1}`));
    if (qty > 1 && eigeneFormen && formen.length > 1) {
      const sel = el('select', 'oset__form');
      sel.setAttribute('aria-label', `Form für Ornament ${i + 1}`);
      formen.forEach((f) => { const o = el('option', null, f); o.value = f; sel.appendChild(o); });
      sel.value = formOf(i);
      sel.addEventListener('change', () => { eigen[i] = sel.value; if (active !== i) setActive(i); else syncPreview(); });
      kopf.appendChild(sel);
    }
    chips(i, row).forEach((c) => kopf.appendChild(c));
    if (kopf.childNodes.length) row.appendChild(kopf);
    felder.forEach((f, k) => {
      const feld = el('div', 'oset__feld');
      const inp = el('input');
      inp.id = `oset-name-${i}${k ? '-' + k : ''}`;
      inp.type = 'text';
      if (f.zahl) { inp.inputMode = 'numeric'; inp.pattern = '[0-9]*'; }
      inp.maxLength = f.max;
      inp.autocomplete = 'off';
      if (f.platzhalter) inp.placeholder = f.platzhalter;
      inp.dataset.key = f.key;
      inp.value = werte[i][f.key] || '';
      const lab = el('label', null, f.titel + (f.pflicht ? ' *' : ''));
      lab.htmlFor = inp.id;
      const cnt = el('span', 'oset__count', `${inp.value.length}/${f.max}`);
      inp.addEventListener('input', () => {
        werte[i][f.key] = inp.value;
        cnt.textContent = `${inp.value.length}/${f.max}`;
        feld.classList.remove('is-err');
        row.classList.remove('is-err');
        if (active !== i) setActive(i); else syncPreview();
      });
      inp.addEventListener('focus', () => { if (active !== i) setActive(i); });
      inp.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        const alle = [...namesBox.querySelectorAll('input[type="text"]')];
        const next = alle[alle.indexOf(inp) + 1];
        if (next) next.focus(); else ctaBtn.focus();
      });
      feld.append(lab, inp, cnt);
      row.appendChild(feld);
    });
    return row;
  }

  function renderNames() {
    const je = jeStueckFelder();
    namesTitle.textContent = (felder.length === 1 ? textTitle : felder.length ? (qty > 1 ? 'Texte je Ornament' : 'Deine Texte') : 'Deine Ornamente')
      + (je.length && felder.length ? ` & ${je[0].titel}` : '');
    namesHint.textContent = hinweisText();
    namesHint.hidden = qty < 2;
    namesBox.textContent = '';
    // ohne Textfelder (z. B. Musik) gibt es bei einem Ornament nichts einzutragen
    namesBox.parentElement.hidden = !felder.length && (qty < 2 || !eigeneFormen || formen.length < 2);
    if (felder.length !== 1) {
      for (let i = 0; i < qty; i++) namesBox.appendChild(zeileMehrfach(i));
      return;
    }
    const key = felder[0].key;
    const beispiel = maxLen >= 30 ? 'z. B. Anna & Markus' : 'z. B. Anna';
    for (let i = 0; i < qty; i++) {
      const row = el('div', 'oset__name' + (qty > 1 && i === active ? ' is-active' : ''));
      row.dataset.i = String(i);
      const inp = el('input');
      inp.id = `oset-name-${i}`;
      inp.type = 'text';
      inp.maxLength = maxLen;
      inp.autocomplete = 'off';
      inp.placeholder = beispiel;
      inp.value = werte[i][key] || '';
      let sel = null;
      if (qty > 1) {
        const lab = el('label', null, `Ornament ${i + 1}`);
        lab.htmlFor = inp.id;
        row.appendChild(lab);
        if (eigeneFormen && formen.length > 1) {
          sel = el('select', 'oset__form');
          sel.setAttribute('aria-label', `Form für Ornament ${i + 1}`);
          formen.forEach((f) => {
            const o = el('option', null, f);
            o.value = f;
            sel.appendChild(o);
          });
          sel.value = formOf(i);
          sel.addEventListener('change', () => {
            eigen[i] = sel.value;
            if (active !== i) setActive(i); else syncPreview();
          });
          row.classList.add('has-form');
        }
      } else {
        inp.setAttribute('aria-label', textTitle);
      }
      const cnt = el('span', 'oset__count', `${(werte[i][key] || '').length}/${maxLen}`);
      inp.addEventListener('input', () => {
        werte[i][key] = inp.value;
        cnt.textContent = `${inp.value.length}/${maxLen}`;
        row.classList.remove('is-err');
        if (active !== i) setActive(i); else syncPreview();
      });
      inp.addEventListener('focus', () => { if (active !== i) setActive(i); });
      inp.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        const next = document.getElementById(`oset-name-${i + 1}`);
        if (next) next.focus(); else ctaBtn.focus();
      });
      if (sel) row.append(sel);
      // Auswahl je Ornament (z. B. Hunderasse) als Bild links neben dem Namen
      const cs = chips(i, row);
      if (cs.length) { row.classList.add('has-chip'); row.append(...cs); }
      row.append(inp, cnt);
      namesBox.appendChild(row);
    }
  }
  // Formwahl der Zeilen nachziehen (oben neue Form für alle gewählt), ohne die Namensfelder neu zu bauen
  function syncFormSelects() {
    namesBox.querySelectorAll('.oset__name').forEach((r) => {
      const sel = r.querySelector('.oset__form');
      if (sel) sel.value = formOf(Number(r.dataset.i));
    });
  }

  function renderPrices() {
    const sub = total(qty);
    const full = PRICE * qty;
    summaryBox.textContent = '';
    const row = (a, b, cls) => {
      const r = el('div', 'oset__row' + (cls ? ' ' + cls : ''));
      r.append(el('span', null, a), el('span', null, b));
      summaryBox.appendChild(r);
      return r;
    };
    row(`${qty} × ${eur(PRICE)}`, eur(full));
    if (pct(qty)) row(`Mengenrabatt (−${pct(qty)} %)`, `−${eur(full - sub)}`, 'is-minus');
    const boxen = boxSumme(qty);
    if (boxen) row(`Geschenkverpackung ${qty} × ${eur(BOX_PRICE)}`, eur(boxen));
    renderBoxNote();
    const summe = sub + boxen;
    if (korbLeer) {
      const ship = shipFor(summe);
      row('Versand', ship ? eur(ship) : 'gratis', ship ? '' : 'is-free');
      if (ship && FREE) {
        summaryBox.appendChild(el('div', 'oset__gap', `Noch ${eur(FREE - summe)} bis zum Gratisversand`));
        const bar = el('div', 'oset__bar');
        const fill = el('i');
        fill.style.width = `${Math.min(100, (summe / FREE) * 100)}%`;
        bar.appendChild(fill);
        summaryBox.appendChild(bar);
      }
      row('Gesamt', eur(summe + ship), 'is-total');
    } else {
      // im Warenkorb liegt schon etwas: Versand hängt vom ganzen Warenkorb ab
      row('Zwischensumme', eur(summe), 'is-total');
      if (FREE) summaryBox.appendChild(el('div', 'oset__gap', `Versand gratis ab ${eur(FREE)} Warenkorbwert`));
    }
    ctaLabel.textContent = `${plural(qty)} in den Warenkorb · ${eur(summe)}`;
    if (stickyLabel) stickyLabel.textContent = plural(qty);
    if (stickyPrice) stickyPrice.textContent = eur(summe);
  }
  const renderAll = () => { renderTiles(); renderNames(); renderPrices(); };

  // ---------- In den Warenkorb ----------
  // Zeitmessung bei Bedarf: in der Browser-Konsole window.OSET_DEBUG = true setzen
  const t0debug = performance.now();
  const dbg = (msg) => { if (window.OSET_DEBUG) console.log(`[oset ${Math.round(performance.now() - t0debug)} ms] ${msg}`); };

  let knownCount = null; // Artikel im Warenkorb, spart eine Abfrage pro Ornament
  const klar = (t) => String(t || '').toLowerCase().replace(/\s+/g, '');
  const artworkShows = (name) => [...document.querySelectorAll('svg.tee-mockup-artwork .tee-layer-text')]
    .some((t) => klar(t.textContent).includes(klar(name)));
  // teeinblue schreibt manche Felder in Großbuchstaben um (Familie Socken: Vornamen) → ohne Groß/klein vergleichen
  const steht = (o) => (!o.form || formValue() === o.form)
    && felder.every((f) => { const inp = feldInput(f.key); return inp && klar(inp.value) === klar(o.werte[f.key]); })
    && buchstabeSteht(erstes(o.werte))
    && jeStueckSteht(o.wahl);
  // teeinblue meldet fehlende Pflichtangaben (z. B. Foto, Design, Song) im Formular; die Meldung ist im Theme
  // ausgeblendet, steht aber im DOM
  const pflichtFehlt = () => /Pflichtfeld/i.test(((scope().querySelector('.tee-form-responses') || {}).textContent || ''));
  async function addViaTee(o) {
    const name = erstes(o.werte) || `Ornament ${o.i + 1}`;
    dbg(`Start ${name} (${o.form})`);
    await stelleEin(o.form, o.werte, 2500, o.wahl);
    await sleep(150);
    // Form und Texte müssen wirklich stehen, sonst noch einmal setzen
    if (!(await waitUntil(() => steht(o), 1500, 60))) {
      dbg('Form/Texte stehen noch nicht, setze erneut');
      await stelleEin(o.form, o.werte, 2500, o.wahl);
      if (!(await waitUntil(() => steht(o), 3000, 60))) throw new Error('Form oder Name nicht gesetzt');
    }
    const sichtbar = felder.map((f) => o.werte[f.key]).find(Boolean);
    if (sichtbar) await waitUntil(() => artworkShows(sichtbar), 3000, 80);
    if (!tee.atc()) throw new Error('kein teeinblue-Button');
    await waitUntil(() => !tee.atc().classList.contains('tee-processing'), 15000, 80);
    if (knownCount == null) knownCount = (await fetchCart()).item_count;
    const before = knownCount;
    dbg('Klick auf teeinblue-Button');
    const ok = await new Promise((resolve) => {
      let settled = false;
      const finish = (v) => {
        if (settled) return;
        settled = true;
        document.removeEventListener('teeinblue-event-after-cart-added', onAdded);
        resolve(v);
      };
      const onAdded = () => { dbg('teeinblue meldet: im Warenkorb'); finish(true); };
      document.addEventListener('teeinblue-event-after-cart-added', onAdded);
      (async () => {
        const t0 = Date.now();
        while (!settled && Date.now() - t0 < 25000) {
          await sleep(600);
          if (pflichtFehlt() && !tee.atc().classList.contains('tee-processing')) { finish('pflicht'); break; }
          try { if ((await fetchCart()).item_count > before) finish(true); } catch (e) { /* nächster Versuch */ }
        }
        finish(false);
      })();
      tee.atc().click();
    });
    if (ok === 'pflicht') { knownCount = null; throw new Error('pflicht'); }
    if (!ok) { knownCount = null; throw new Error('Zeitüberschreitung'); }
    knownCount = before + 1;
    // teeinblue verknüpft das Design danach noch mit dem Warenkorb (ca. 0,6 s)
    await sleep(700);
    await waitUntil(() => !tee.atc().classList.contains('tee-processing'), 10000, 80);
    dbg(`Fertig ${name}`);
  }

  function validate() {
    // ein Textfeld (erste Ornamente): wie bisher je Ornament der Name
    if (felder.length === 1) {
      const key = felder[0].key;
      const missing = [];
      for (let i = 0; i < qty; i++) if (!String(werte[i][key] || '').trim()) missing.push(i);
      namesBox.querySelectorAll('.oset__name').forEach((r) => r.classList.toggle('is-err', missing.includes(Number(r.dataset.i))));
      let fehler = '';
      if (missing.length) {
        fehler = qty === 1
          ? 'Bitte trage noch den Namen ein.'
          : missing.length === 1 ? 'Bitte trage noch 1 Namen ein.' : `Bitte trage noch ${missing.length} Namen ein.`;
      } else if (buchstabenFeld()) {
        // Buchstabe kommt aus dem Namen → der Name muss mit einem Buchstaben A–Z beginnen
        const ohne = [];
        for (let i = 0; i < qty; i++) if (!buchstabeOption(buchstabenFeld(), werte[i][key])) ohne.push(i);
        namesBox.querySelectorAll('.oset__name').forEach((r) => r.classList.toggle('is-err', ohne.includes(Number(r.dataset.i))));
        if (ohne.length) { missing.push(...ohne); fehler = 'Der Name muss mit einem Buchstaben von A bis Z beginnen.'; }
      }
      if (!missing.length) { errBox.textContent = ''; return true; }
      errBox.textContent = fehler;
      const first = document.getElementById(`oset-name-${missing[0]}`);
      if (first) {
        first.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(() => first.focus({ preventScroll: true }), 350);
      }
      return false;
    }
    // mehrere Textfelder: alle Pflichtfelder je Ornament
    const fehlt = [];
    for (let i = 0; i < qty; i++) {
      felder.forEach((f, k) => {
        const v = String(werte[i][f.key] || '').trim();
        if (f.pflicht && !v) fehlt.push({ i, k, f });
        else if (f.zahl && v && !/^\d+$/.test(v)) fehlt.push({ i, k, f, zahl: true });
      });
    }
    namesBox.querySelectorAll('.oset__name').forEach((r) => {
      const i = Number(r.dataset.i);
      r.classList.toggle('is-err', fehlt.some((x) => x.i === i));
      r.querySelectorAll('.oset__feld').forEach((fe, k) => fe.classList.toggle('is-err', fehlt.some((x) => x.i === i && x.k === k)));
    });
    if (!fehlt.length) { errBox.textContent = ''; return true; }
    const x = fehlt[0];
    const wo = qty === 1 ? '' : ` bei Ornament ${x.i + 1}`;
    errBox.textContent = x.zahl
      ? `Bitte trage${wo} bei „${x.f.titel}“ nur Ziffern ein.`
      : qty === 1
        ? `Bitte fülle noch „${x.f.titel}“ aus.`
        : `Bitte fülle${wo} noch „${x.f.titel}“ aus${fehlt.length > 1 ? ` (insgesamt ${fehlt.length} Felder)` : ''}.`;
    const first = document.getElementById(`oset-name-${x.i}${x.k ? '-' + x.k : ''}`);
    if (first) {
      first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      setTimeout(() => first.focus({ preventScroll: true }), 350);
    }
    return false;
  }

  // Fortschrittsfenster
  const modal = el('div', 'oset-modal');
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.hidden = true;
  const card = el('div', 'oset-modal__card');
  const mTitle = el('p', 'oset-modal__title');
  const mBar = el('div', 'oset-modal__bar');
  const mFill = el('i');
  mBar.appendChild(mFill);
  const mList = el('ul', 'oset-modal__list');
  card.append(mTitle, el('p', 'oset-modal__sub', 'Einen Moment, wir legen jedes Ornament mit seinem Namen an.'), mBar, mList);
  modal.appendChild(card);
  document.body.appendChild(modal);

  async function addAll() {
    if (busy) return;
    if (!validate()) return;
    busy = true;
    clearTimeout(syncT);
    await kette; // laufenden Vorschau-Wechsel erst zu Ende bringen
    knownCount = null;
    const list = werte.slice(0, qty).map((w, i) => ({ i, werte: sauber(w), wahl: { ...wahl[i] }, form: formOf(i) }));
    const gemischt = new Set(list.map((o) => o.form)).size > 1;
    mList.textContent = '';
    const items = list.map((o) => {
      const li = el('li');
      const st = el('span', 'oset-modal__st', '·');
      const name = erstes(o.werte);
      const auswahl = wahlName(o.wahl);
      const text = (list.length > 1 ? `Ornament ${o.i + 1}${name ? ': ' + name : ''}` : name || 'Ornament') + (auswahl ? ` (${auswahl})` : '') + (gemischt && o.form ? ` (${o.form})` : '');
      li.append(el('span', null, text), st);
      mList.appendChild(li);
      return { li, st };
    });
    const mitBox = boxAn();
    let boxItem = null;
    if (mitBox) {
      const li = el('li');
      const st = el('span', 'oset-modal__st', '·');
      li.append(el('span', null, `Geschenkverpackung × ${list.length}`), st);
      mList.appendChild(li);
      boxItem = { li, st };
    }
    // gleiche Formen hintereinander anlegen (jeder Formwechsel kostet Zeit), mit der gerade gezeigten beginnen
    const jetzt = formValue();
    const rang = (f) => (f === jetzt ? -1 : formen.indexOf(f));
    const folge = list.slice().sort((a, b) => rang(a.form) - rang(b.form) || a.i - b.i);
    mFill.style.width = '0';
    mTitle.textContent = list.length > 1 ? 'Deine Ornamente werden erstellt …' : 'Dein Ornament wird erstellt …';
    modal.hidden = false;
    ctaBtn.disabled = true;
    document.documentElement.classList.add('oset-busy');
    let added = 0;
    try {
      for (const o of folge) {
        if (list.length > 1) mTitle.textContent = `Ornament ${added + 1} von ${list.length} wird erstellt …`;
        items[o.i].st.textContent = '';
        items[o.i].st.appendChild(el('span', 'oset-spin'));
        await addViaTee(o);
        added++;
        items[o.i].li.classList.add('is-done');
        items[o.i].st.textContent = '✓';
        mFill.style.width = `${(added / list.length) * 100}%`;
      }
      let boxOk = true;
      if (mitBox) {
        mTitle.textContent = 'Geschenkverpackung wird hinzugefügt …';
        boxItem.st.textContent = '';
        boxItem.st.appendChild(el('span', 'oset-spin'));
        try {
          await addBoxes(added);
          boxItem.li.classList.add('is-done');
          boxItem.st.textContent = '✓';
          refreshDrawer(await fetchCart());
        } catch (e) {
          boxOk = false;
          boxItem.st.textContent = '–';
        }
      }
      mTitle.textContent = 'Fertig!';
      await sleep(500);
      modal.hidden = true;
      if (!boxOk) errBox.textContent = `${added === 1 ? 'Das Ornament liegt' : 'Die Ornamente liegen'} im Warenkorb. Die Geschenkverpackung konnte gerade nicht hinzugefügt werden.`;
      const drawer = document.getElementById('mini-cart');
      if (drawer) drawer.open = true;
    } catch (e) {
      modal.hidden = true;
      if (e && e.message === 'pflicht') {
        // teeinblue vermisst eine Angabe oben im Formular (Foto, Design, Song …)
        errBox.textContent = (added ? `${plural(added)} ${added === 1 ? 'liegt' : 'liegen'} schon im Warenkorb. ` : '')
          + `Bitte ${hatFoto() ? 'lade oben noch das Foto hoch bzw. ' : ''}fülle oben noch alle Pflichtangaben aus (mit * markiert).`;
        const form = document.querySelector('form.tee-form-wrapper');
        if (form) form.scrollIntoView({ block: 'start', behavior: 'smooth' });
      } else {
        errBox.textContent = added
          ? `${plural(added)} ${added === 1 ? 'liegt' : 'liegen'} schon im Warenkorb, die übrigen konnten nicht angelegt werden. Bitte prüfe den Warenkorb und versuche es noch einmal.`
          : 'Das Ornament konnte gerade nicht angelegt werden. Bitte versuche es noch einmal.';
      }
    } finally {
      busy = false;
      ctaBtn.disabled = false;
      document.documentElement.classList.remove('oset-busy');
      syncPreview(); // Vorschau wieder auf das aktive Ornament
      await loadCart();
      renderTiles();
      renderPrices();
    }
  }

  // ---------- Sticky-Leiste fürs Handy ----------
  let stickyLabel = null;
  let stickyPrice = null;
  function mountSticky() {
    const bar = el('div', 'oset-sticky');
    const txt = el('div', 'oset-sticky__txt');
    stickyLabel = el('span');
    stickyPrice = el('b');
    txt.append(stickyLabel, stickyPrice);
    const b = el('button', 'oset-sticky__btn', 'In den Warenkorb');
    b.type = 'button';
    b.addEventListener('click', addAll);
    bar.append(txt, b);
    document.body.appendChild(bar);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-shown', !entry.isIntersecting && entry.boundingClientRect.top > 0);
      });
      io.observe(ctaBtn);
    }
  }

  // ---------- Start ----------
  ctaBtn.addEventListener('click', addAll);
  if (boxCheck) boxCheck.addEventListener('change', () => { if (!root.hidden) renderPrices(); });
  document.addEventListener('variant:changed', (e) => {
    const v = e.detail && e.detail.variant;
    if (v && typeof v.price === 'number') { PRICE = v.price; renderTiles(); renderPrices(); }
  });
  // Kunde wählt oben eine Form: Sie gilt für alle Ornamente ohne eigene Wahl und für das aktive.
  // teeinblue leert danach das Textfeld, deshalb den Namen anschließend wieder setzen.
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (progKlick || busy || !t || t.type !== 'radio' || !t.closest || !t.closest('form.tee-form-wrapper .tee-option--color')) return;
    basis = t.value;
    eigen[active] = null;
    syncFormSelects();
    nacheinander(async () => {
      await nextCustomization(1500);
      if (!busy) applyToTee(sauber(werte[active]), wahl[active]);
    });
  });
  // Kunde wählt oben im Feld je Ornament (teeinblue, z. B. Hunderasse): gilt für das gerade gewählte Ornament. teeinblue
  // meldet die Wahl nicht als normales change-Ereignis → den Klick selbst lesen (Capture, vor teeinblue). Eigene Klicks
  // der Box laufen mit progAuswahl und zählen nicht.
  document.addEventListener('click', (e) => {
    if (progAuswahl || busy || root.hidden) return;
    const c = e.target && e.target.closest && e.target.closest('form.tee-form-wrapper .tee-field--clipart .tee-clipart');
    if (!c) return;
    const feld = c.closest('.tee-field--clipart');
    if (!feld || !JE_STUECK.includes(feldTitel(feld).toLowerCase())) return;
    const input = c.querySelector('input[type="radio"]');
    const key = feldKey(feld);
    if (!input || !key || wahl[active][key] === input.value) return;
    wahl[active][key] = input.value;
    setTimeout(() => { renderNames(); markiereFeld(); }, 0); // Bild in der Zeile nachziehen
  }, true);
  // Warenkorb an anderer Stelle geändert (z. B. im Warenkorb-Fenster etwas entfernt): Staffel neu rechnen
  ['cart:updated', 'cart:refresh'].forEach((ev) => {
    document.addEventListener(ev, (e) => {
      if (busy) return;
      if (readCart(e.detail && e.detail.cart)) { renderTiles(); renderPrices(); } else loadCart().then(() => { renderTiles(); renderPrices(); });
    });
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) loadCart().then(() => { renderTiles(); renderPrices(); }); });

  // Textfelder neu einlesen (teeinblue baut sie z. B. bei „Anzahl Personen“ neu auf): Werte bleiben je Feld
  // erhalten, neue Felder bekommen die Vorgabe von teeinblue
  function uebernimmFelder(neu) {
    neu.forEach((f) => werte.forEach((w) => { if (!(f.key in w)) w[f.key] = f.vorgabe; }));
    felder = neu;
    if (felder[0]) { textTitle = felder[0].titel; maxLen = felder[0].max; }
  }
  const sig = (liste) => liste.map((f) => f.key).join(',');

  (async () => {
    const ready = await waitUntil(() => tee.atc(), 20000, 200);
    if (!ready) return; // kein teeinblue → normales Formular bleibt sichtbar
    await sleep(600); // teeinblue baut die Felder kurz nach dem Knopf auf
    // Vorgaben wie die Jahreszahl setzt teeinblue teils erst etwas später ein (vorher steht „undefined“ im Feld)
    await waitUntil(() => ![...scope().querySelectorAll('.tee-field--text')].some((f) => { const i = f.querySelector(EINGABE); return i && i.value === 'undefined'; }), 3000, 150);
    uebernimmFelder(liesFelder());
    eigeneFormen = !hatFoto();
    // Auswahl je Ornament: Vorgabe = die oben gewählte Möglichkeit (sonst die erste); das Feld oben bleibt sichtbar
    jeStueckFelder().forEach((f) => {
      const an = f.el.querySelector('input[type="radio"]:checked');
      const v = (an && an.value) || (optionen(f.el)[0] || {}).value;
      wahl.forEach((a) => { if (!a[f.key]) a[f.key] = v; });
    });
    // ohne die Formen, die nicht mehr angeboten werden (data-ohne-formen in snippets/ornamente-motiv.liquid)
    const motivBox = document.querySelector('[data-omotiv]');
    const ohne = ((motivBox && motivBox.dataset.ohneFormen) || '').split(',').map((s) => s.trim()).filter(Boolean);
    formen = formRadios().map((i) => i.value).filter((f) => !ohne.includes(f));
    basis = formen.includes(formValue()) ? formValue() : formen[0] || null;
    // nach einem Motiv-Wechsel: Anzahl, Namen und eigene Formen übernehmen (Formen nur, wenn es sie hier gibt)
    const w = window.ornamenteWechsel;
    if (w) {
      if (w.qty) qty = Math.max(1, Math.min(MAX, Number(w.qty) || 1));
      if (felder[0]) (w.texte || []).slice(0, MAX).forEach((t, i) => { if (t) werte[i][felder[0].key] = String(t).slice(0, maxLen); });
      (w.formen || []).slice(0, MAX).forEach((f, i) => { eigen[i] = formen.includes(f) ? f : null; });
    }
    await loadCart();
    // Geschenkverpackung vor Zusammenfassung und Knopf zeigen (der Block der Vorlage steht sonst darunter)
    if (boxWrap && BOX_ID) summaryBox.parentElement.insertBefore(boxWrap, summaryBox);
    document.documentElement.classList.add('oset-on');
    root.hidden = false;
    mountSticky();
    renderAll();
    syncPreview();
    // Formular beobachten: andere Textfelder (Anzahl Personen o. Ä.) → Zeilen neu bauen; Buchstaben-Auswahl
    // ausblenden, sobald sie erscheint (teeinblue zeichnet sie nach der Design-Wahl neu)
    setInterval(() => {
      if (busy) return;
      markiereFeld();
      const lb = buchstabenFeld();
      if (lb && !lb.classList.contains('oset-auto')) { lb.classList.add('oset-auto'); namesHint.textContent = hinweisText(); syncPreview(); }
      const neu = liesFelder();
      if (sig(neu) !== sig(felder)) { uebernimmFelder(neu); renderNames(); syncPreview(); }
    }, 1000);
  })();
})();
